export default "__VITE_ASSET__ufHuz7vN__"